import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';

import Breadcrumbs from '~/components/core/Atomic/Breadcrumbs';
import Typography from '~/components/core/Atomic/Typography';

const linkStyle = { textDecoration: 'none', color: '#202020', fontSize: '14px' };

interface IntermediateTab {
  label: string;
  to: string;
}

interface OperationsBreadcrumbsProps {
  currentTab: string;
  intermediateTabs?: IntermediateTab[];
  addPadding?: boolean;
}

/**
 * Breadcrumbs for Operations pages.
 * Renders: Operations > [intermediateTabs...] > currentTab
 */
const OperationsBreadcrumbs: React.FC<OperationsBreadcrumbsProps> = ({
  currentTab,
  intermediateTabs = [],
  addPadding = false,
}) => {
  const match = useRouteMatch();

  const isInsideOperationsTab = match.url.split('/').includes('operations');

  if (!isInsideOperationsTab) {
    return null;
  }

  return (
    <Breadcrumbs aria-label="breadcrumb" style={addPadding ? { padding: '10px 0px 0px 30px' } : undefined}>
      <Link to="/sysconfig/operations" style={linkStyle}>
        Operations
      </Link>
      {intermediateTabs.map((tab, index) => (
        <Link key={index} to={tab.to} style={linkStyle}>
          {tab.label}
        </Link>
      ))}
      <Typography color="textPrimary" style={{ fontWeight: 600 }}>
        {currentTab}
      </Typography>
    </Breadcrumbs>
  );
};

export default OperationsBreadcrumbs;
